var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 133,
    viewBox: "0 0 144 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.1 94.0699C99.147 107.533 83.8415 116.429 66.5012 116.429C38.9761 116.429 16.5716 94.0359 16.5716 66.5C16.5716 38.9641 38.9761 16.5826 66.5012 16.5826C82.1798 16.5826 96.1854 23.8509 105.353 35.1999L125.157 35.1999C113.944 14.2653 91.8673 0 66.5012 0C29.8312 0 0 29.8306 0 66.5C0 103.169 29.8312 133 66.5012 133C93.3368 133 116.499 117.005 127 94.0586L108.1 94.0586V94.0699Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 57.4122L117.352 57.4122L117.352 45L131.559 45V57.4122L144 57.4122V71.6889L131.559 71.6889V84L117.352 84L117.352 71.6889H105V57.4122Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3387 55.1731C53.3387 50.2415 49.6062 50.1048 48.846 50.1048C47.3938 50.1048 44.0016 51.0046 44.0016 55.7312V57.1207L31.8963 57.1207V54.7631C31.8963 46.7107 37.081 39 48.9822 39C59.4992 39 66 45.1845 66 53.4419C66 59.4784 62.4716 63.9317 58.1831 69.6948L51.8865 78.4419L65.9319 78.4419V89L31 89L46.4295 67.8155C52.1702 60.0364 53.3501 58.1572 53.3501 55.1731H53.3387Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4325 50.83L72 50.83V40L92 40L92 89L80.4325 89L80.4325 50.8413V50.83Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourIcon);
export default __webpack_public_path__ + "static/media/hour-icon.7d3b3ed1f6e70a03fd5e4c8c41711652.svg";
export { ForwardRef as ReactComponent };